<!-- 柱状图 -->
<template>
    <div class="coloRback">
        <el-button type="primary" @click="handleClick()" style="margin-top:10px;">添加</el-button>
        <el-table :data="indicator" style="width: 90%" header-align="center" class="coloRtable">
            <el-table-column label="名称"  align="center"  >
                <template #default="scope">
                    {{scope.row.name}}
                  <!-- <div :style="{background:scope.row}" class="backgrgba"></div> -->
                </template>
            </el-table-column>
            <el-table-column label="最大值"   align="center" >
            <template #default="scope">
                {{scope.row.max}}
            </template>
            </el-table-column>
            <el-table-column label="编辑"  align="center" >
            <template #default="scope" >
                <el-button link type="primary" size="small" @click="handleClick(scope,true)">
                编辑
                </el-button>
                <el-button link type="primary" size="small" @click="del(scope.$index)">删除</el-button>
            </template>
            </el-table-column>

         </el-table>
         <!-- 修改 -->
         <el-dialog
            v-model="dialogVisible"
            title="添加/修改"
            width="500"
            :before-close="handleClose"
        >
            <div class = 'row'>
                <p class = 'title'>名称</p>
                <p class = 'setvalue'>
                <el-input
                    v-model="modificationColor.name"
                    style="max-width: 600px"
                    placeholder=""
                >
                </el-input>
                </p>
            </div>
            <div class = 'row'>
                <p class = 'title'>最大值</p>
                <p class = 'setvalue'>
                <el-input
                    v-model="modificationColor.max"
                    style="max-width: 600px"
                    placeholder=""
                >
                </el-input>
                </p>
            </div>
            <template #footer>
            <div class="dialog-footer">
                <el-button @click="cancel">取消</el-button>
                <el-button type="primary" @click="determine">
                 确定
                </el-button>
            </div>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import { getCurrentInstance,ref,onMounted,onUnmounted,watch,shallowRef,computed } from "vue";
import * as echarts from 'echarts';
import { useStore } from 'vuex';
import { colorCustomMerge, cloneDeep  } from '../../../utils'// 
import { ElMessage, ElMessageBox } from 'element-plus'
// import sj from './components/json/sj.json'
export default {
    props: {
        indicator: {
            type: Array,
            default: function () { return {} }
        },
        // yearRef:{
        //     type: String,
        //     default: function () { return "2024" }
        // }
    },
    setup(props,ctx) {
        const { proxy } = getCurrentInstance();
        const option = ref({})
        const barChartRef = shallowRef(null);
        const chartInstance = shallowRef(null);
       
        const store = useStore();
        // const canvasConfig = ref(computed(() => store.state.chartData.canvasConfig));
        // const comChartColors = ref(colorCustomMerge())
        const indicator=ref(props.indicator)
        // if(Backcolor.value){
        //     if(canvasConfig.value.theme){
        //         Backcolor.value= JSON.parse(JSON.stringify(comChartColors.value[canvasConfig.value.theme].color)) 
        //     }
        // }
        const selectIndex1=ref(null)
        const dialogVisible= ref(false)
        const modificationColor=ref({name:'',max:'',name1:''})
        const  handleClick=((row)=>{
             selectIndex1.value=null
             if(row){
                selectIndex1.value=row.$index
                modificationColor.value=row.row
                modificationColor.value.name1=row.row.name
             }
             dialogVisible.value=true
        })
        //确定
        const  determine=(()=>{
            console.log(selectIndex1.value!=null,'electIndex1.value!=null')
            if(selectIndex1.value!=null){
                indicator.value[selectIndex1.value]=modificationColor.value
            } else{
                indicator.value.push(modificationColor.value)
            }
             dialogVisible.value=false
             ctx.emit('indicatoradd',indicator.value)
        })
        // 删除
        const  del=((index)=>{
            ElMessageBox.confirm(
            '是否删除该色块?',
            '删除颜色',
            {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            draggable: true,
            }
        )
            .then(() => {
                ElMessage({
                    type: 'success',
                    message: '删除成功',
                })
                console.log( indicator.value,' Backcolor.value')
                indicator.value.splice(index,1)
                console.log( indicator.value,' Backcolor.value11111')
                ctx.emit('indicatordel',indicator.value)
            })
            .catch(() => {
            
            // ElMessage({
            //     type: 'info',
            //     message: 'Delete canceled',
            // })
            })
            // selectIndex1.value=''
            // modificationColor.value=''  
            // dialogVisible.value=false
        })
        // 取消
        const  cancel=(()=>{
            selectIndex1.value=''
            modificationColor.value=''  
            dialogVisible.value=false
        })
        return{
            option,
            barChartRef,
            indicator,
            handleClick,
            selectIndex1,
            dialogVisible,
            modificationColor,
            determine,
            cancel,
            del
        }
    }
}
</script>

<style scoped lang="less">
.coloRback{
    background: #000;
}
 .coloRback .row{
    display: flex;
    align-items: center;
    height:50px;

    // background:#000;
    .title{
      width:100px;
      height:30px;
      line-height:30px;
      text-align: left;
      color:#000;
    }
    .setvalue{
      flex:1;
      padding-right:20px;
      box-sizing: border-box;
      .el-input{
        background:pink!important;
      }
      
    }
  }
 :deep(.el-table__cell){
    background: #000 !important;
  }
  :deep(.is-leaf) {
    border: none !important;
  }
  :deep(td) {
    border: none !important;
  }
  :deep(.el-table__inner-wrapper::before){
    background-color:#000;
  }
.chart {
    width: 100%;
    height: 100vh;
}
.coloRback {
  margin-left: 25px;
}
.backgrgba {
    width: 20px;
    height: 20px;
    border-radius:5px ;

}
.coloRtable :deep(.cell)  {
    display: flex ;
    justify-content: center ;
    align-items: center ;
}


</style>